export const SET_FY_START_MONTHS_LOADED = "SET_FY_START_MONTHS_LOADED";

export const setFyStartMonthsLoaded = (fyStartMonthsLoaded: boolean) => {
  return {
    fyStartMonthsLoaded,
    type: SET_FY_START_MONTHS_LOADED
  };
};
